import React, { Component } from "react";
import { connect } from "react-redux";

import { TextField, Select } from "./FormElements";
import Icon from "./Icons";
import ProductFilter from "./ProductFilter";
import ListSortedItemsCheckboxes from "./ListSortedItemsCheckboxes";
import { validURL, l, pagesOptions } from "../functions";

const mapStateToProps = (state) => {
  return {
    fetchedPages: state.rootReducer.fetchedPages || [],
    fetchedCategories: state.rootReducer.fetchedCategories || {},
    fetchedLangs: state.rootReducer.fetchedLangs || [],
    currentLang: state.rootReducer.currentLang || 1,
  };
};

class MenuDialog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      linkType: "",
    };
  }

  componentWillReceiveProps({ currentMenu }) {
    if (currentMenu) {
      if (this.props.currentMenu) {
        if (currentMenu.menu_id != this.props.currentMenu.menu_id) {
          if (currentMenu.url && currentMenu.url.includes("__")) {
            this.setState({
              linkType: currentMenu.url.split("__")[0],
            });
          }
        }
      } else {
        if (currentMenu.url && currentMenu.url.includes("__")) {
          this.setState({
            linkType: currentMenu.url.split("__")[0],
          });
        } else {
          this.setState({
            linkType: "",
          });
        }
      }
    }
  }

  _changedField = (key, value) => {
    this.props.onChange(key, value);
  };

  _changedCurrentLang = (event) => {
    this.props.onChangeCurrentLang(event.target.value);
  };

  _changedLinkType = (value) => {
    this.setState({ linkType: value });
  };

  render() {
    const menuDatas = Object.assign(
      this.props.currentMenu || {},
      this.props.menuDatas || {}
    );

    window.$menu = menuDatas;

    let menuTarget = menuDatas.target || "";

    return (
      (this.props.currentMenu && this.props.open && (
        <div className="menu-dialog">
          <div className="head">
            <Icon icon="time" onClick={this.props.onClose} />{" "}
            <h3>{l("Edit menu element")}</h3>
            <button className="new-item" onClick={this.props.onSubmit}>
              <Icon icon="check" />
            </button>
          </div>
          <div className="form">
            {this.props.fetchedLangs &&
              this.props.fetchedLangs.map((lang, index) => {
                let label = "";
                try {
                  label = JSON.parse(menuDatas.label)[lang.value];
                } catch (err) {
                  console.log(err);
                }

                return (
                  this.props.currentLang == lang.value && (
                    <div className="section" key={index}>
                      <TextField
                        label={l("Label")}
                        solid
                        dark
                        value={(menuDatas && menuDatas.label && label) || ""}
                        onChange={(value) => {
                          this._changedField("label_" + lang.value, value);
                        }}
                      />
                    </div>
                  )
                );
              })}

            <div className="section">
              <ul className="inline-options dark grow">
                <li
                  onClick={() => {
                    this._changedField("target", "_self");
                  }}
                  className={menuTarget !== "_blank" ? "selected" : ""}
                >
                  <span>{l("Same window")}</span>
                </li>
                <li
                  onClick={() => {
                    this._changedField("target", "_blank");
                  }}
                  className={menuTarget === "_blank" ? "selected" : ""}
                >
                  <span>{l("New window")}</span>
                </li>
              </ul>
            </div>
            <div className="section">
              <div className="gk-form-row-container">
                <label className="small">{l("Link type")}</label>
                <Select
                  placeholder={l("Link type")}
                  value={this.state.linkType || ""}
                  onChange={(value) => {
                    this._changedLinkType(value);
                  }}
                  options={[
                    {
                      label: l("Custom"),
                      value: "custom",
                    },
                    {
                      label: l("Product"),
                      value: "product",
                    },
                    {
                      label: l("Category"),
                      value: "category",
                    },
                    {
                      label: l("Page"),
                      value: "cms",
                    },
                  ]}
                  dark
                />
              </div>
            </div>
            {this.state.linkType === "product" && (
              <div className="section">
                <ProductFilter
                  label={l("Filter product")}
                  list={
                    menuDatas.url.includes("product__")
                      ? menuDatas.url.replace("product__", "")
                      : ""
                  }
                  onCheck={(product) => {
                    this._changedField("url", "product__" + product);
                  }}
                />
              </div>
            )}
            {this.state.linkType === "category" && (
              <div className="section">
                <label className="small">{l("Select a category")}</label>
                <ListSortedItemsCheckboxes
                  list={
                    menuDatas.url.includes("category__")
                      ? menuDatas.url.replace("category__", "")
                      : ""
                  }
                  onCheck={(list) => {
                    this._changedField("url", "category__" + list);
                  }}
                  items={this.props.fetchedCategories.leveled}
                  inlineItems={this.props.fetchedCategories.normal}
                />
              </div>
            )}
            {this.state.linkType === "cms" && (
              <div className="section">
                <div className="gk-form-row-container">
                  <label className="small">{l("Page")}</label>
                  <Select
                    placeholder={l("Select page")}
                    value={menuDatas.url.includes("cms__") ? menuDatas.url : ""}
                    onChange={(value) => {
                      this._changedField("url", value);
                    }}
                    options={pagesOptions("cms")}
                    dark
                  />
                </div>
              </div>
            )}
            {this.state.linkType === "custom" && (
              <div className="section">
                <TextField
                  placeholder={l("Custom url")}
                  info={l("Secured link is recommanded")}
                  value={
                    menuDatas.url.includes("custom__")
                      ? menuDatas.url.replace("custom__", "")
                      : ""
                  }
                  onChange={(value) => {
                    this._changedField("url", "custom__" + value);
                  }}
                  dark
                  error={
                    !validURL(
                      menuDatas.url.includes("custom__")
                        ? menuDatas.url.replace("custom__", "")
                        : ""
                    )
                      ? l("Url format not correct")
                      : false
                  }
                />
              </div>
            )}
            {this.state.linkType === "popup" && (
              <div className="section">
                <div className="gk-form-row-container">
                  <label className="small">{l("Popup")}</label>
                  <Select
                    placeholder={l("Select popup")}
                    value={
                      menuDatas.url.includes("modal_payload__")
                        ? menuDatas.url
                        : ""
                    }
                    onChange={(value) => {
                      this._changedField("url", value);
                    }}
                    options={pagesOptions("modal_payload")}
                    dark
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      )) || <div></div>
    );
  }
}

export default connect(mapStateToProps)(MenuDialog);
